module.exports = __webpack_public_path__ + "img/mockup-fratelli.58fa569.jpg";